import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { JupiterTheme } from '../../theme/types';
import CopyToClipboard from '../util/CopyToClipboard';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    content: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
    title: {
      textAlign: 'center',
    },
    inputField: {
      width: '80%',
      marginBottom: theme.spacing(2.25),
    },
    shareButton: {
      marginBottom: theme.spacing(1),
    },
    stopSharingButton: {
      marginLeft: theme.spacing(2),
    },
    actionButtons: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    description: {
      marginBottom: theme.spacing(2.25),
    },
  })
);

interface Props extends DialogProps {
  link?: string;
  type: string;
  helperText?: string;
  onStartSharing?: VoidFunction;
  onStopSharing?: VoidFunction;
  description?: string;
  sharing?: boolean;
  dataTestId?: string;
}

const ShareModal = ({
  link,
  type,
  onStartSharing,
  helperText,
  onStopSharing,
  description,
  sharing,
  dataTestId = 'share-modal',
  ...props
}: Props) => {
  const classes = useStyles();

  return (
    <Dialog maxWidth="sm" fullWidth {...props} data-testid={dataTestId}>
      <DialogTitle className={classes.title}>Share {type}</DialogTitle>
      <DialogContent className={classes.content}>
        {link ? (
          <>
            <TextField value={link} className={classes.inputField} />
            <div className={classes.actionButtons}>
              <CopyToClipboard text={link}>
                <Button variant="contained" color="primary">
                  Copy link
                </Button>
              </CopyToClipboard>
              {onStopSharing && (
                <Button
                  variant="text"
                  color="primary"
                  onClick={onStopSharing}
                  className={classes.stopSharingButton}
                >
                  Stop sharing
                </Button>
              )}
            </div>
          </>
        ) : (
          <>
            <Typography color="textSecondary" className={classes.description}>
              {description}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={onStartSharing}
              className={classes.shareButton}
            >
              {sharing ? (
                <CircularProgress color="secondary" size={24} />
              ) : (
                'Create link'
              )}
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ShareModal;
